import React, { useEffect, useState } from "react";
import contact from "../../Images/contact-img.svg";
import "./Contact.css";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Contactpage = () => {
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  function handleMailTo() {
    const name = document.getElementById("name").value.trim();
    const email = document.getElementById("email").value.trim();
    const message = document.getElementById("message").value.trim();

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!name) {
      setNameError("Please enter your name.");
      return;
    } else {
      setNameError("");
    }

    if (!email) {
      setEmailError("Please enter your email.");
      return;
    } else {
      setEmailError("");
    }

    if (!emailPattern.test(email)) {
      setEmailError("Please enter a valid email address.");
      return;
    } else {
      setEmailError("");
    }

    const mailtoLink = `mailto:info@owision.com?subject=Contact Form Submission&body=Name: ${encodeURIComponent(
      name
    )}%0DEmail: ${encodeURIComponent(email)}%0DMessage: ${encodeURIComponent(message)}`;

    window.open(mailtoLink, "_self");
    resetData();
  }

  const resetData = () => {
    document.getElementById("name").value = "";
    document.getElementById("email").value = "";
    document.getElementById("message").value = "";
  };

  return (
    <>
      <div style={{ background: "white" }}>
        <div
          className="contact-page-container mainContainer"
          style={{ paddingTop: location.pathname === "/contact" ? "5rem" : "0" }}
        >
          <div className="left-content">
            <div className="header-contact">
              <h1 style={{ fontSize: window.innerWidth <= 768 ? "24px" : "40px" }}>Contact us</h1>
              <p>Get in touch to see how we can help you.</p>
              <p>info@owision.com</p>
              <img src={contact} alt="contact" />
            </div>
          </div>
          <div className="right-content-contact">
            <div className="form-content">
              <div className="first-last-content" style={{ width: "100%" }}>
                <div className="firstname-content" style={{ width: "50%", position: "relative" }}>
                  <p>First Name</p>
                  <input
                    type="text"
                    placeholder=" Name"
                    id="name"
                    style={{
                      padding: ".7rem",
                      background: "#F6F6FA",
                      border: "none",
                      borderRadius: "12px",
                      width: "100%",
                    }}
                  />
                  {nameError && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "12px",
                        position: "absolute",
                        bottom: "-20px",
                      }}
                    >
                      {nameError}
                    </p>
                  )}
                  {}
                </div>
                <div className="firstname-content" style={{ width: "50%", position: "relative" }}>
                  <p>Email</p>
                  <input
                    type="email"
                    id="email"
                    placeholder="Enter Your mail"
                    style={{
                      padding: ".7rem",
                      background: "#F6F6FA",
                      border: "none",
                      borderRadius: "12px",
                      width: "100%",
                    }}
                  />
                  {emailError && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "12px",
                        position: "absolute",
                        bottom: "-20px",
                      }}
                    >
                      {emailError}
                    </p>
                  )}
                  {}
                </div>
              </div>
              <div className="message-content">
                <p>Add your message</p>
                <textarea
                  id="message"
                  style={{
                    padding: ".7rem",
                    background: "#F6F6FA",
                    border: "none",
                    borderRadius: "12px",
                    height: "200px",
                    width: "100%",
                    resize: "none",
                  }}
                  placeholder="Enter your message"
                ></textarea>
              </div>
              <button className="btn-bordeer" onClick={handleMailTo}>
                Submit
              </button>
            </div>
          </div>
        </div>
        {location.pathname === "/contact" && (
          <div className="mapAdress" style={{ padding: "2rem 0", width: "85%", margin: "0 auto" }}>
            <div className="map">
              <iframe
                src="https://www.google.com/maps/d/embed?mid=1BIcE2TH2tbmD-mEvlEBGXG6bKnvd4XE&ehbc=2E312F&noprof=1"
                width="100%"
                height="580"
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Contactpage;
